// Produktion i18n — AI-assisterede oversættelser (kan finpudses her)
export const LANGS = [
  { code: "da", label: "Dansk" },
  { code: "ar", label: "العربية" },
  { code: "ku", label: "Kurmancî" },
  { code: "ti", label: "ትግርኛ" },
];
export const RTL_LANGS = ["ar"];

export const DICT = {
  da: {
    fb_archived: "Arkiverede",
    dept_svejsning: "Svejseafdeling",
    dept_montage: "Montageafdeling",
    dept_slibning: "Slibeafdeling",
    documents: "dokumenter",
    search_placeholder: "Søg på titel, dok.nr., varenr. eller kunde…",
    no_results: "Ingen dokumenter fundet",
    new_document: "Nyt dokument",
    status_Kladde: "Kladde",
    status_Godkendt: "Godkendt",
    status_Afvist: "Afvist",
    "status_I gang": "I gang",
    "status_Færdig": "Færdig",
    "status_Indført på stykliste": "Indført på stykliste",
    print_report: "Print",
    type: "Type",
    docno: "Dok.nr.",
    varenr: "Varenr.",
    customer: "Kunde",
    date: "Dato",
    title: "Titel",
    add_image: "Tilføj billede",
    take_photo: "Tag billede",
    upload_drive: "Upload fra drev",
    back: "Tilbage",
    saving: "Gemmer…",
    saved: "Gemt",
    share: "Del med kunde",
    delete: "Slet",
    bom_pre: "BOMs og tilhørende tegninger er ",
    bom_strong: "altid",
    bom_post: " gældende for materiale-/komponentvalg og udførelse.",
    copied: "Dok.nr. kopieret",
    images: "Billeder",
    edit: "Rediger",
    prod: "Produktion",
    page_documents: "Dokumenter",
    desc_default: "Dokumentér svejsning, montage og slibning med billeder, markeringer og konklusion.",
    desc_svejsning: "Dokumentér svejsning med billeder, markeringer og konklusion.",
    desc_montage: "Dokumentér montage med billeder, markeringer og konklusion.",
    desc_slibning: "Dokumentér slibning med billeder, markeringer og konklusion.",
    type_svejsning: "Svejsning",
    type_montage: "Montage",
    type_slibning: "Slibning",
    create_document: "Opret dokument",
    export_excel: "Eksportér til Excel",
    toast_export_err: "Kunne ikke eksportere til Excel",
    creating: "Opretter…",
    quick_view: "Hurtig visning",
    all_reports: "Alle rapporter",
    saved_filters: "Gemte filtre",
    none_saved: "Ingen gemte endnu",
    filters: "Filtre",
    save_current: "Gem nuværende",
    status_label: "Status",
    all_types: "Alle typer",
    all_statuses: "Alle statusser",
    search_label: "Søg",
    title_or_item: "Titel eller varenr.",
    reset_filters: "Nulstil filtre",
    loading: "Indlæser…",
    empty_title: "Ingen dokumenter endnu",
    empty_desc: "Opret dit første produktionsdokument for at komme i gang.",
    no_match: "Ingen dokumenter matcher de valgte filtre.",
    col_document: "Dokument",
    col_responsible: "Ansvarlig",
    col_status: "Status",
    col_version: "Version",
    col_updated: "Opdateret",
    col_action: "Handling",
    untitled: "Uden titel",
    new_document_desc: "Vælg en skabelon. Du kan altid tilpasse alt bagefter.",
    tpl_svejsning_desc: "Svejsedokumentation",
    tpl_montage_desc: "Montagedokumentation",
    tpl_slibning_desc: "Slibningsdokumentation",
    cancel: "Annullér",
    create_and_edit: "Opret & rediger",
    save_filter: "Gem filter",
    save_filter_desc: "Giv dit filter et navn, så du hurtigt kan hente det igen.",
    filter_name_ph: "Fx: Mine svejsedokumenter",
    save: "Gem",
    delete_document: "Slet dokument",
    delete_confirm_pre: "Er du sikker på at du vil slette ",
    delete_confirm_post: "? Handlingen kan ikke fortrydes.",
    toast_filter_saved: "Filter gemt",
    toast_filter_save_err: "Kunne ikke gemme filter",
    toast_filter_deleted: "Filter slettet",
    toast_doc_deleted: "Dokument slettet",
    toast_doc_delete_err: "Kunne ikke slette dokumentet",
    toast_doc_created: "Dokument oprettet",
    toast_doc_create_err: "Kunne ikke oprette",
    toast_share_err: "Kunne ikke oprette delingslink",
    document_word: "Dokument",
    changes: "Ændringer…",
    settings: "Indstillinger",
    tools: "Værktøjer",
    share_btn: "Del",
    details: "Detaljer",
    no_customer: "Ingen kunde",
    version_control: "Versionsstyring",
    ver_notice_title: "OBS: Der er lavet en versionsændring",
    ver_notice_body: "Vær' særlig opmærksom på at læse dokumentet igennem.",
    ver_notice_ok: "Jeg har forstået",
    created_on: "Oprettet",
    history: "Historik",
    no_description: "Ingen beskrivelse",
    new_version: "Ny version",
    description: "Beskrivelse",
    write_description: "Skriv beskrivelse…",
    documentation: "Dokumentation",
    edit_and_mark: "Rediger & marker",
    image_caption_ph: "Tilføj tekst til billedet…",
    remarks: "Bemærkninger",
    remark_desc_ph: "Beskriv bemærkningen",
    no_remarks: "Ingen bemærkninger registreret.",
    add_remark: "Tilføj bemærkning",
    level_Mindre: "Mindre",
    "level_Væsentlig": "Væsentlig",
    level_Kritisk: "Kritisk",
    conclusion: "Konklusion",
    conclusion_note_ph: "Begrundelse / bemærkning",
    responsible: "Ansvarlig",
    version_label: "Version",
    title_ph: "Dokumenttitel",
    autotranslate_hint: "Skriv på dit eget sprog — teksten gemmes automatisk på dansk.",
    autotranslate_label: "Auto-oversæt",
    on: "Til",
    off: "Fra",
    prev_action: "Forebyggende handling",
    corr_action: "Korrigerende handling",
    version_history: "Versionshistorik",
    overview: "Overblik",
    not_set: "Ikke fastlagt",
    no_version_note: "Ingen beskrivelse angivet.",
    updated_short: "Opdateret",
    last_updated_label: "Sidst opdateret",
    report_for: "Rapport for",
    dept_produktion: "Produktion",
    dept_kvalitet: "Kvalitet",
    readonly_view: "Skrivebeskyttet visning",
    translating: "Oversætter…",
    at_time: "kl.",
    annot_title: "Marker på billedet",
    annot_desc: "Tilføj pile, kryds, cirkler og markeringer for at fremhæve detaljer.",
    done: "Færdig",
    share_dialog_desc: "Send dette link til kunden. Dokumentet vises skrivebeskyttet i BSM-design.",
    copy: "Kopiér",
    open_customer_view: "Åbn kundevisning",
    new_link: "Nyt link",
    deactivate: "Deaktivér",
    create_link: "Opret link",
    rev_desc: "Beskriv kort hvad der er ændret. Teksten vises i versionshistorikken på delingssiden.",
    rev_note_ph: "Fx: Tilføjet foto + rettet varenr.",
    create_version: "Opret version",
    delete_document_q: "Slet dokument?",
    action_undone: "Handlingen kan ikke fortrydes.",
    doc_type_fallback: "Dokument",
    toast_doc_not_found: "Dokument ikke fundet",
    toast_img_uploaded: "Billede uploadet",
    toast_upload_failed: "Upload fejlede",
    toast_save_failed: "Kunne ikke gemme",
    toast_link_copied: "Link kopieret",
    toast_new_link_gen: "Nyt link genereret",
    toast_link_deactivated: "Link deaktiveret",
    toast_link_create_err: "Kunne ikke oprette link",
    toast_link_regen_err: "Kunne ikke generere nyt link",
    toast_link_deact_err: "Kunne ikke deaktivere link",
    version_created_pre: "Version ",
    version_created_post: " oprettet",
    hist_updated: "Historik opdateret på delingssiden.",
    toast_version_err: "Kunne ikke oprette version",
  },
  ar: {
    fb_filter: "تصفية",
    fb_saved: "عوامل التصفية المحفوظة",
    fb_none_saved: "لا توجد محفوظات بعد",
    fb_save_current: "حفظ الحالي…",
    fb_showing: "عرض {n} من {t}",
    fb_reset: "إعادة تعيين",
    fb_archived: "المؤرشفة",
    fb_period: "الفترة",
    fb_add_filter: "إضافة تصفية",
    fb_combine: "دمج",
    fb_and: "و",
    fb_or: "أو",
    fb_clear: "مسح",
    fb_done: "تم",
    fb_no_match: "لا توجد نتائج",
    fb_custom_period: "فترة مخصصة",
    fb_to: "إلى",
    fb_search_in: "ابحث في {f}…",
    fb_p30d: "آخر 30 يومًا",
    fb_p3m: "آخر 3 أشهر",
    fb_pyear: "هذا العام",
    fb_plast: "العام الماضي",
    fb_pdf: "حفظ كـ PDF",
    fb_export_view: "تصدير ما تراه",
    fb_more: "المزيد من التصديرات",
    dept_svejsning: "قسم اللحام",
    dept_montage: "قسم التركيب",
    dept_slibning: "قسم الجلخ",
    documents: "مستندات",
    search_placeholder: "ابحث حسب العنوان أو رقم المستند أو رقم الصنف أو العميل…",
    no_results: "لم يتم العثور على مستندات",
    new_document: "مستند جديد",
    status_Kladde: "مسودة",
    status_Godkendt: "معتمد",
    status_Afvist: "مرفوض",
    "status_I gang": "قيد التنفيذ",
    "status_Færdig": "مكتمل",
    "status_Indført på stykliste": "أُدرج في قائمة المواد",
    print_report: "طباعة",
    type: "النوع",
    docno: "رقم المستند",
    varenr: "رقم الصنف",
    customer: "العميل",
    date: "التاريخ",
    title: "العنوان",
    add_image: "إضافة صورة",
    take_photo: "التقاط صورة",
    upload_drive: "رفع من الجهاز",
    back: "رجوع",
    saving: "جارٍ الحفظ…",
    saved: "تم الحفظ",
    share: "مشاركة مع العميل",
    delete: "حذف",
    bom_pre: "قوائم المواد (BOMs) والرسومات المرفقة ",
    bom_strong: "دائماً",
    bom_post: " سارية المفعول لاختيار المواد/المكونات والتنفيذ.",
    copied: "تم نسخ رقم المستند",
    images: "الصور",
    edit: "تعديل",
    prod: "الإنتاج",
    page_documents: "المستندات",
    desc_default: "وثّق اللحام والتركيب والجلخ بالصور والعلامات والاستنتاج.",
    desc_svejsning: "وثّق اللحام بالصور والعلامات والاستنتاج.",
    desc_montage: "وثّق التركيب بالصور والعلامات والاستنتاج.",
    desc_slibning: "وثّق الجلخ بالصور والعلامات والاستنتاج.",
    type_svejsning: "لحام",
    type_montage: "تركيب",
    type_slibning: "جلخ",
    create_document: "إنشاء مستند",
    export_excel: "تصدير إلى Excel",
    toast_export_err: "تعذّر التصدير إلى Excel",
    creating: "جارٍ الإنشاء…",
    quick_view: "عرض سريع",
    all_reports: "كل التقارير",
    saved_filters: "المرشحات المحفوظة",
    none_saved: "لا شيء محفوظ بعد",
    filters: "المرشحات",
    save_current: "حفظ الحالي",
    status_label: "الحالة",
    all_types: "كل الأنواع",
    all_statuses: "كل الحالات",
    search_label: "بحث",
    title_or_item: "العنوان أو رقم الصنف",
    reset_filters: "إعادة ضبط المرشحات",
    loading: "جارٍ التحميل…",
    empty_title: "لا توجد مستندات بعد",
    empty_desc: "أنشئ أول مستند إنتاج للبدء.",
    no_match: "لا توجد مستندات تطابق المرشحات المحددة.",
    col_document: "المستند",
    col_responsible: "المسؤول",
    col_status: "الحالة",
    col_version: "الإصدار",
    col_updated: "آخر تحديث",
    col_action: "إجراء",
    untitled: "بدون عنوان",
    new_document_desc: "اختر قالباً. يمكنك تعديل كل شيء لاحقاً.",
    tpl_svejsning_desc: "توثيق اللحام",
    tpl_montage_desc: "توثيق التركيب",
    tpl_slibning_desc: "توثيق الجلخ",
    cancel: "إلغاء",
    create_and_edit: "إنشاء وتعديل",
    save_filter: "حفظ المرشح",
    save_filter_desc: "امنح مرشحك اسماً لتسترجعه بسرعة.",
    filter_name_ph: "مثال: مستندات اللحام الخاصة بي",
    save: "حفظ",
    delete_document: "حذف المستند",
    delete_confirm_pre: "هل أنت متأكد أنك تريد حذف ",
    delete_confirm_post: "؟ لا يمكن التراجع عن هذا الإجراء.",
    toast_filter_saved: "تم حفظ المرشح",
    toast_filter_save_err: "تعذّر حفظ المرشح",
    toast_filter_deleted: "تم حذف المرشح",
    toast_doc_deleted: "تم حذف المستند",
    toast_doc_delete_err: "تعذّر حذف المستند",
    toast_doc_created: "تم إنشاء المستند",
    toast_doc_create_err: "تعذّر الإنشاء",
    toast_share_err: "تعذّر إنشاء رابط المشاركة",
    document_word: "مستند",
    changes: "تغييرات…",
    settings: "الإعدادات",
    tools: "الأدوات",
    share_btn: "مشاركة",
    details: "التفاصيل",
    no_customer: "لا يوجد عميل",
    version_control: "إدارة الإصدارات",
    ver_notice_title: "تنبيه: تم إجراء تغيير في الإصدار",
    ver_notice_body: "يرجى الانتباه بشكل خاص وقراءة المستند بالكامل.",
    ver_notice_ok: "لقد فهمت",
    created_on: "أُنشئ في",
    history: "السجل",
    no_description: "لا يوجد وصف",
    new_version: "إصدار جديد",
    description: "الوصف",
    write_description: "اكتب وصفاً…",
    documentation: "التوثيق",
    edit_and_mark: "تعديل ووضع علامات",
    image_caption_ph: "أضف نصاً للصورة…",
    remarks: "الملاحظات",
    remark_desc_ph: "صف الملاحظة",
    no_remarks: "لم يتم تسجيل أي ملاحظات.",
    add_remark: "إضافة ملاحظة",
    level_Mindre: "طفيف",
    "level_Væsentlig": "متوسط",
    level_Kritisk: "حرج",
    conclusion: "الاستنتاج",
    conclusion_note_ph: "التبرير / ملاحظة",
    responsible: "المسؤول",
    version_label: "الإصدار",
    title_ph: "عنوان المستند",
    autotranslate_hint: "اكتب بلغتك — يُحفظ النص تلقائياً باللغة الدنماركية.",
    autotranslate_label: "ترجمة تلقائية",
    on: "مفعّل",
    off: "متوقف",
    prev_action: "إجراء وقائي",
    corr_action: "إجراء تصحيحي",
    version_history: "سجل الإصدارات",
    overview: "نظرة عامة",
    not_set: "غير محدد",
    no_version_note: "لا يوجد وصف.",
    updated_short: "محدّث",
    last_updated_label: "آخر تحديث",
    report_for: "تقرير لـ",
    dept_produktion: "الإنتاج",
    dept_kvalitet: "الجودة",
    readonly_view: "عرض للقراءة فقط",
    translating: "جارٍ الترجمة…",
    at_time: "الساعة",
    annot_title: "ضع علامات على الصورة",
    annot_desc: "أضف أسهماً وعلامات ودوائر ومؤشرات لإبراز التفاصيل.",
    done: "تم",
    share_dialog_desc: "أرسل هذا الرابط للعميل. يُعرض المستند للقراءة فقط بتصميم BSM.",
    copy: "نسخ",
    open_customer_view: "فتح عرض العميل",
    new_link: "رابط جديد",
    deactivate: "تعطيل",
    create_link: "إنشاء رابط",
    rev_desc: "صف باختصار ما تم تغييره. يظهر النص في سجل الإصدارات في صفحة المشاركة.",
    rev_note_ph: "مثال: أضيفت صورة + صُحّح رقم الصنف.",
    create_version: "إنشاء إصدار",
    delete_document_q: "حذف المستند؟",
    action_undone: "لا يمكن التراجع عن هذا الإجراء.",
    doc_type_fallback: "مستند",
    toast_doc_not_found: "المستند غير موجود",
    toast_img_uploaded: "تم رفع الصورة",
    toast_upload_failed: "فشل الرفع",
    toast_save_failed: "تعذّر الحفظ",
    toast_link_copied: "تم نسخ الرابط",
    toast_new_link_gen: "تم إنشاء رابط جديد",
    toast_link_deactivated: "تم تعطيل الرابط",
    toast_link_create_err: "تعذّر إنشاء الرابط",
    toast_link_regen_err: "تعذّر إنشاء رابط جديد",
    toast_link_deact_err: "تعذّر تعطيل الرابط",
    version_created_pre: "الإصدار ",
    version_created_post: " تم إنشاؤه",
    hist_updated: "تم تحديث السجل في صفحة المشاركة.",
    toast_version_err: "تعذّر إنشاء الإصدار",
  },
  ku: {
    fb_filter: "Parzûn",
    fb_saved: "Parzûnên tomarkirî",
    fb_none_saved: "Hîn tune",
    fb_save_current: "Ya niha tomar bike…",
    fb_showing: "{n} ji {t} tê nîşandan",
    fb_reset: "Vegerîne",
    fb_archived: "Arşîvkirî",
    fb_period: "Dem",
    fb_add_filter: "Parzûnê zêde bike",
    fb_combine: "Bihevre",
    fb_and: "Û",
    fb_or: "An",
    fb_clear: "Paqij bike",
    fb_done: "Temam",
    fb_no_match: "Tişt nehat dîtin",
    fb_custom_period: "Dema taybet",
    fb_to: "heta",
    fb_search_in: "Li {f} bigere…",
    fb_p30d: "30 rojên dawî",
    fb_p3m: "3 mehên dawî",
    fb_pyear: "Îsal",
    fb_plast: "Sala borî",
    fb_pdf: "Wek PDF tomar bike",
    fb_export_view: "Ya tu dibînî derxe",
    fb_more: "Derxistinên din",
    dept_svejsning: "Beşa Kaynakê",
    dept_montage: "Beşa Montajê",
    dept_slibning: "Beşa Sûtinê",
    documents: "belge",
    search_placeholder: "Li gorî sernav, jimara belgeyê, parçe an xerîdar bigere…",
    no_results: "Tu belge nehat dîtin",
    new_document: "Belgeya nû",
    status_Kladde: "Reşnivîs",
    status_Godkendt: "Pejirandî",
    status_Afvist: "Redkirî",
    "status_I gang": "Di pêvajoyê de",
    "status_Færdig": "Qediya",
    "status_Indført på stykliste": "Li lîsteya materyalan hate tomarkirin",
    print_report: "Çap",
    type: "Cure",
    docno: "Jimara belgeyê",
    varenr: "Jimara parçeyê",
    customer: "Xerîdar",
    date: "Dîrok",
    title: "Sernav",
    add_image: "Wêne zêde bike",
    take_photo: "Wêne bikişîne",
    upload_drive: "Ji cîhazê bar bike",
    back: "Vegere",
    saving: "Tê tomarkirin…",
    saved: "Hat tomarkirin",
    share: "Bi xerîdar re parve bike",
    delete: "Jê bibe",
    bom_pre: "BOM û nexşeyên girêdayî ",
    bom_strong: "her tim",
    bom_post: " ji bo hilbijartina materyal/parçe û pêkanînê derbasdar in.",
    copied: "Jimara belgeyê hat kopîkirin",
    images: "Wêne",
    edit: "Biguherîne",
    prod: "Hilberîn",
    page_documents: "Belge",
    desc_default: "Kaynak, montaj û sûtinê bi wêne, nîşan û encaman belge bike.",
    desc_svejsning: "Kaynakê bi wêne, nîşan û encaman belge bike.",
    desc_montage: "Montajê bi wêne, nîşan û encaman belge bike.",
    desc_slibning: "Sûtinê bi wêne, nîşan û encaman belge bike.",
    type_svejsning: "Kaynak",
    type_montage: "Montaj",
    type_slibning: "Sûtin",
    create_document: "Belge çêbike",
    export_excel: "Hinardana Excel",
    toast_export_err: "Hinardan bo Excel neserkeftî",
    creating: "Tê çêkirin…",
    quick_view: "Dîtina bilez",
    all_reports: "Hemû rapor",
    saved_filters: "Parzûnên tomarkirî",
    none_saved: "Hê tu tişt nehat tomarkirin",
    filters: "Parzûn",
    save_current: "Ya heyî tomar bike",
    status_label: "Rewş",
    all_types: "Hemû cure",
    all_statuses: "Hemû rewş",
    search_label: "Lêgerîn",
    title_or_item: "Sernav an jimara parçe",
    reset_filters: "Parzûnan ji nû ve saz bike",
    loading: "Tê barkirin…",
    empty_title: "Hê tu belge tune",
    empty_desc: "Ji bo destpêkê belgeya xwe ya yekem a hilberînê çêbike.",
    no_match: "Tu belge bi parzûnên hilbijartî re li hev nayên.",
    col_document: "Belge",
    col_responsible: "Berpirsyar",
    col_status: "Rewş",
    col_version: "Guherto",
    col_updated: "Nûvekirî",
    col_action: "Kirin",
    untitled: "Bê sernav",
    new_document_desc: "Şablonekê hilbijêre. Tu dikarî her tiştî paşê biguherînî.",
    tpl_svejsning_desc: "Belgekirina kaynakê",
    tpl_montage_desc: "Belgekirina montajê",
    tpl_slibning_desc: "Belgekirina sûtinê",
    cancel: "Betal bike",
    create_and_edit: "Çêbike & biguherîne",
    save_filter: "Parzûnê tomar bike",
    save_filter_desc: "Navê parzûna xwe bide da ku bilez wê vegerînî.",
    filter_name_ph: "Wek: Belgeyên min ên kaynakê",
    save: "Tomar bike",
    delete_document: "Belgeyê jê bibe",
    delete_confirm_pre: "Ma tu piştrast î ku dixwazî jê bibî ",
    delete_confirm_post: "? Ev kirin nayê vegerandin.",
    toast_filter_saved: "Parzûn hat tomarkirin",
    toast_filter_save_err: "Parzûn nehat tomarkirin",
    toast_filter_deleted: "Parzûn hat jêbirin",
    toast_doc_deleted: "Belge hat jêbirin",
    toast_doc_delete_err: "Belge nehat jêbirin",
    toast_doc_created: "Belge hat çêkirin",
    toast_doc_create_err: "Nehat çêkirin",
    toast_share_err: "Girêdana parvekirinê nehat çêkirin",
    document_word: "Belge",
    changes: "Guhertin…",
    settings: "Mîheng",
    tools: "Amûr",
    share_btn: "Parve bike",
    details: "Hûragahî",
    no_customer: "Tu xerîdar tune",
    version_control: "Rêveberiya guhertoyan",
    ver_notice_title: "BAL: Guhertoyek nû hatiye çêkirin",
    ver_notice_body: "Ji kerema xwe bi taybetî bala xwe bide û belgeyê baş bixwîne.",
    ver_notice_ok: "Min fêm kir",
    created_on: "Hatiye çêkirin",
    history: "Dîrok",
    no_description: "Tu daxuyanî tune",
    new_version: "Guhertoya nû",
    description: "Daxuyanî",
    write_description: "Daxuyaniyekê binivîse…",
    documentation: "Belgekirin",
    edit_and_mark: "Biguherîne & nîşan bike",
    image_caption_ph: "Ji bo wêneyê nivîsê zêde bike…",
    remarks: "Têbînî",
    remark_desc_ph: "Têbîniyê rave bike",
    no_remarks: "Tu têbînî nehat tomarkirin.",
    add_remark: "Têbînî zêde bike",
    level_Mindre: "Piçûk",
    "level_Væsentlig": "Girîng",
    level_Kritisk: "Krîtîk",
    conclusion: "Encam",
    conclusion_note_ph: "Sedem / têbînî",
    responsible: "Berpirsyar",
    version_label: "Guherto",
    title_ph: "Sernavê belgeyê",
    autotranslate_hint: "Bi zimanê xwe binivîse — nivîs bixweber bi Danîmarkî tê tomarkirin.",
    autotranslate_label: "Werger otomatîk",
    on: "Vekirî",
    off: "Girtî",
    prev_action: "Tedbîra pêşîlêgirtinê",
    corr_action: "Tedbîra rastkirinê",
    version_history: "Dîroka guhertoyan",
    overview: "Giştî",
    not_set: "Nediyar",
    no_version_note: "Tu şirove nehatiye dayîn.",
    updated_short: "Nûvekirî",
    last_updated_label: "Dawî nûvekirin",
    report_for: "Rapor ji bo",
    dept_produktion: "Hilberîn",
    dept_kvalitet: "Kalîte",
    readonly_view: "Dîtina tenê-xwendin",
    translating: "Tê wergerandin…",
    at_time: "saet",
    annot_title: "Li ser wêneyê nîşan bike",
    annot_desc: "Ji bo ronîkirina hûragahiyan tîr, xaç, xelek û nîşanan zêde bike.",
    done: "Qediya",
    share_dialog_desc: "Vê girêdanê ji xerîdar re bişîne. Belge di sêwirana BSM de tenê-xwendin tê nîşandan.",
    copy: "Kopî bike",
    open_customer_view: "Dîtina xerîdar veke",
    new_link: "Girêdana nû",
    deactivate: "Neçalak bike",
    create_link: "Girêdanê çêbike",
    rev_desc: "Bi kurtî rave bike ku çi hat guhertin. Nivîs di dîroka guhertoyan de li rûpela parvekirinê xuya dibe.",
    rev_note_ph: "Wek: Wêne hat zêdekirin + jimara parçe hat serrastkirin.",
    create_version: "Guhertoyê çêbike",
    delete_document_q: "Belge jê bibe?",
    action_undone: "Ev kirin nayê vegerandin.",
    doc_type_fallback: "Belge",
    toast_doc_not_found: "Belge nehat dîtin",
    toast_img_uploaded: "Wêne hat barkirin",
    toast_upload_failed: "Barkirin bi ser neket",
    toast_save_failed: "Nehat tomarkirin",
    toast_link_copied: "Girêdan hat kopîkirin",
    toast_new_link_gen: "Girêdana nû hat çêkirin",
    toast_link_deactivated: "Girêdan hat neçalakkirin",
    toast_link_create_err: "Girêdan nehat çêkirin",
    toast_link_regen_err: "Girêdana nû nehat çêkirin",
    toast_link_deact_err: "Girêdan nehat neçalakkirin",
    version_created_pre: "Guhertoya ",
    version_created_post: " hat çêkirin",
    hist_updated: "Dîrok li rûpela parvekirinê hat nûvekirin.",
    toast_version_err: "Guherto nehat çêkirin",
  },
  ti: {
    fb_filter: "መጻረዪ",
    fb_saved: "ዝተዓቀቡ መጻረዪታት",
    fb_none_saved: "ገና የለን",
    fb_save_current: "ህሉው ኣቐምጥ…",
    fb_showing: "{n} ካብ {t} ይርአ",
    fb_reset: "ዳግም ኣቐምጥ",
    fb_archived: "ዝተዓቀቡ",
    fb_period: "እዋን",
    fb_add_filter: "መጻረዪ ወስኽ",
    fb_combine: "ኣወሃህድ",
    fb_and: "ከምኡውን",
    fb_or: "ወይ",
    fb_clear: "ኣጽሪ",
    fb_done: "ተወዲኡ",
    fb_no_match: "ዝሰማማዕ የለን",
    fb_custom_period: "ናይ ገዛእ ርእስኻ እዋን",
    fb_to: "ክሳብ",
    fb_search_in: "ኣብ {f} ድለ…",
    fb_p30d: "ዝሓለፉ 30 መዓልታት",
    fb_p3m: "ዝሓለፉ 3 ኣዋርሕ",
    fb_pyear: "ሎሚ ዓመት",
    fb_plast: "ዝሓለፈ ዓመት",
    fb_pdf: "ከም PDF ኣቐምጥ",
    fb_export_view: "ዝርአ ኣውጽእ",
    fb_more: "ተወሳኺ ምውጻእ",
    dept_svejsning: "ክፍሊ ዌልዲንግ",
    dept_montage: "ክፍሊ ምትካል",
    dept_slibning: "ክፍሊ ምፍሓቕ",
    documents: "ሰነዳት",
    search_placeholder: "ብኣርእስቲ፡ ቁ. ሰነድ፡ ቁ. ኣቕሓ ወይ ዓሚል ድለ…",
    no_results: "ዝኾነ ሰነድ ኣይተረኽበን",
    new_document: "ሓድሽ ሰነድ",
    status_Kladde: "ንድፊ",
    status_Godkendt: "ጸዲቑ",
    status_Afvist: "ተነጺጉ",
    "status_I gang": "ኣብ ምስራሕ",
    "status_Færdig": "ተወዲኡ",
    "status_Indført på stykliste": "ኣብ ዝርዝር ኣቕሓ ተመዝጊቡ",
    print_report: "ሕተም",
    type: "ዓይነት",
    docno: "ቁ. ሰነድ",
    varenr: "ቁ. ኣቕሓ",
    customer: "ዓሚል",
    date: "ዕለት",
    title: "ኣርእስቲ",
    add_image: "ስእሊ ወስኽ",
    take_photo: "ስእሊ ኣልዕል",
    upload_drive: "ካብ ድራይቭ ስቐል",
    back: "ተመለስ",
    saving: "ይዕቅብ ኣሎ…",
    saved: "ተዓቂቡ",
    share: "ምስ ዓሚል ኣካፍል",
    delete: "ደምስስ",
    bom_pre: "BOMs ን ተዛመድቲ ስእልታትን ",
    bom_strong: "ኩሉ ግዜ",
    bom_post: " ንምርጫ ኣቑሑ/ኣካላትን ኣፈጻጽማን ዘገልግሉ እዮም።",
    copied: "ቁ. ሰነድ ተቐዲሑ",
    images: "ስእልታት",
    edit: "ኣርትዕ",
    prod: "ፍርያት",
    page_documents: "ሰነዳት",
    desc_default: "ዌልዲንግ፡ ምትካልን ምፍሓቕን ብስእልታት፡ ምልክታትን መደምደምታን ኣስንድ።",
    desc_svejsning: "ዌልዲንግ ብስእልታት፡ ምልክታትን መደምደምታን ኣስንድ።",
    desc_montage: "ምትካል ብስእልታት፡ ምልክታትን መደምደምታን ኣስንድ።",
    desc_slibning: "ምፍሓቕ ብስእልታት፡ ምልክታትን መደምደምታን ኣስንድ።",
    type_svejsning: "ዌልዲንግ",
    type_montage: "ምትካል",
    type_slibning: "ምፍሓቕ",
    create_document: "ሰነድ ፍጠር",
    export_excel: "ናብ Excel ኣውጽእ",
    toast_export_err: "ናብ Excel ምውጻእ ኣይተኻእለን",
    creating: "ይፍጠር ኣሎ…",
    quick_view: "ቅልጡፍ ትርኢት",
    all_reports: "ኩሎም ጸብጻባት",
    saved_filters: "ዝተዓቀቡ መጻረይታት",
    none_saved: "ገና ዝተዓቀበ የለን",
    filters: "መጻረይታት",
    save_current: "ህሉው ዕቀብ",
    status_label: "ኩነታት",
    all_types: "ኩሎም ዓይነታት",
    all_statuses: "ኩሎም ኩነታት",
    search_label: "ድለ",
    title_or_item: "ኣርእስቲ ወይ ቁ. ኣቕሓ",
    reset_filters: "መጻረይታት ኣጽሪ",
    loading: "ይጽዓን ኣሎ…",
    empty_title: "ገና ሰነዳት የለዉን",
    empty_desc: "ንምጅማር ናይ መጀመርታ ናይ ፍርያት ሰነድካ ፍጠር።",
    no_match: "ምስቶም ዝተመርጹ መጻረይታት ዝሰማማዕ ሰነድ የለን።",
    col_document: "ሰነድ",
    col_responsible: "ሓላፊ",
    col_status: "ኩነታት",
    col_version: "ስሪት",
    col_updated: "ተሓዲሱ",
    col_action: "ተግባር",
    untitled: "ብዘይ ኣርእስቲ",
    new_document_desc: "ቅዲ ምረጽ። ድሕሪኡ ኩሉ ግዜ ኩሉ ከተስተኻኽል ትኽእል ኢኻ።",
    tpl_svejsning_desc: "ሰነድ ዌልዲንግ",
    tpl_montage_desc: "ሰነድ ምትካል",
    tpl_slibning_desc: "ሰነድ ምፍሓቕ",
    cancel: "ሰርዝ",
    create_and_edit: "ፍጠር & ኣርትዕ",
    save_filter: "መጻረዪ ዕቀብ",
    save_filter_desc: "ንመጻረዪኻ ስም ሃቦ፡ ብቕልጡፍ ከም እትረኽቦ።",
    filter_name_ph: "ኣብነት፦ ናይ ዌልዲንግ ሰነዳተይ",
    save: "ዕቀብ",
    delete_document: "ሰነድ ደምስስ",
    delete_confirm_pre: "ብርግጽ ክትድምስስ ትደሊ ዲኻ ",
    delete_confirm_post: "? እዚ ተግባር ክምለስ ኣይክእልን።",
    toast_filter_saved: "መጻረዪ ተዓቂቡ",
    toast_filter_save_err: "መጻረዪ ክዕቀብ ኣይከኣለን",
    toast_filter_deleted: "መጻረዪ ተደሚሱ",
    toast_doc_deleted: "ሰነድ ተደሚሱ",
    toast_doc_delete_err: "ሰነድ ክድምሰስ ኣይከኣለን",
    toast_doc_created: "ሰነድ ተፈጢሩ",
    toast_doc_create_err: "ክፍጠር ኣይከኣለን",
    toast_share_err: "መላግቦ ምክፍፋል ክፍጠር ኣይከኣለን",
    document_word: "ሰነድ",
    changes: "ለውጥታት…",
    settings: "ቅንብራት",
    tools: "መሳርሒታት",
    share_btn: "ኣካፍል",
    details: "ዝርዝራት",
    no_customer: "ዓሚል የለን",
    version_control: "ምሕደራ ስሪት",
    ver_notice_title: "ኣቓልቦ፦ ለውጢ ስሪት ተገይሩ ኣሎ",
    ver_notice_body: "ነቲ ሰነድ ብጥንቃቐ ኣንብቦ።",
    ver_notice_ok: "ተረዲኡኒ",
    created_on: "ተፈጢሩ",
    history: "ታሪኽ",
    no_description: "መግለጺ የለን",
    new_version: "ሓድሽ ስሪት",
    description: "መግለጺ",
    write_description: "መግለጺ ጽሓፍ…",
    documentation: "ሰነድ",
    edit_and_mark: "ኣርትዕ & ምልክት ግበር",
    image_caption_ph: "ንስእሊ ጽሑፍ ወስኽ…",
    remarks: "ርእይቶታት",
    remark_desc_ph: "ነቲ ርእይቶ ግለጽ",
    no_remarks: "ዝኾነ ርእይቶ ኣይተመዝገበን።",
    add_remark: "ርእይቶ ወስኽ",
    level_Mindre: "ንኡስ",
    "level_Væsentlig": "ኣገዳሲ",
    level_Kritisk: "ወሳኒ",
    conclusion: "መደምደምታ",
    conclusion_note_ph: "ምኽንያት / ርእይቶ",
    responsible: "ሓላፊ",
    version_label: "ስሪት",
    title_ph: "ኣርእስቲ ሰነድ",
    autotranslate_hint: "ብናትካ ቋንቋ ጽሓፍ — እቲ ጽሑፍ ብቐጥታ ብዳኒሽ ይዕቀብ።",
    autotranslate_label: "ኣውቶማቲክ ትርጉም",
    on: "ወሊዑ",
    off: "ጠፊኡ",
    prev_action: "መከላኸሊ ስጉምቲ",
    corr_action: "ኣረሚ ስጉምቲ",
    version_history: "ታሪኽ ስሪት",
    overview: "ሓፈሻዊ ትርኢት",
    not_set: "ኣይተወሰነን",
    no_version_note: "መግለጺ ኣይተዋህበን።",
    updated_short: "ተሓዲሱ",
    last_updated_label: "ናይ መወዳእታ ምሕዳስ",
    report_for: "ጸብጻብ ን",
    dept_produktion: "ፍርያት",
    dept_kvalitet: "ጽሬት",
    readonly_view: "ንንባብ ጥራይ ትርኢት",
    translating: "ይትርጉም ኣሎ…",
    at_time: "ሰዓት",
    annot_title: "ኣብ ስእሊ ምልክት ግበር",
    annot_desc: "ንዝርዝራት ንምጉላሕ ፍላጻታት፡ መስቀላት፡ ኽቢታትን ምልክታትን ወስኽ።",
    done: "ተወዲኡ",
    share_dialog_desc: "ነዚ መላግቦ ናብ ዓሚል ስደዶ። እቲ ሰነድ ብ BSM ዲዛይን ንንባብ ጥራይ ይረአ።",
    copy: "ቅዳሕ",
    open_customer_view: "ትርኢት ዓሚል ክፈት",
    new_link: "ሓድሽ መላግቦ",
    deactivate: "ኣይንጡፍ ግበር",
    create_link: "መላግቦ ፍጠር",
    rev_desc: "እንታይ ከም እተቐየረ ብሓጺሩ ግለጽ። እቲ ጽሑፍ ኣብ ታሪኽ ስሪት ናይ ገጽ ምክፍፋል ይረአ።",
    rev_note_ph: "ኣብነት፦ ስእሊ ተወሲኹ + ቁ. ኣቕሓ ተኣሪሙ",
    create_version: "ስሪት ፍጠር",
    delete_document_q: "ሰነድ ይደምሰስ?",
    action_undone: "እዚ ተግባር ክምለስ ኣይክእልን።",
    doc_type_fallback: "ሰነድ",
    toast_doc_not_found: "ሰነድ ኣይተረኽበን",
    toast_img_uploaded: "ስእሊ ተሰቒሉ",
    toast_upload_failed: "ምስቃል ኣይተዓወተን",
    toast_save_failed: "ክዕቀብ ኣይከኣለን",
    toast_link_copied: "መላግቦ ተቐዲሑ",
    toast_new_link_gen: "ሓድሽ መላግቦ ተፈጢሩ",
    toast_link_deactivated: "መላግቦ ኣይንጡፍ ኮይኑ",
    toast_link_create_err: "መላግቦ ክፍጠር ኣይከኣለን",
    toast_link_regen_err: "ሓድሽ መላግቦ ክፍጠር ኣይከኣለን",
    toast_link_deact_err: "መላግቦ ኣይንጡፍ ክግበር ኣይከኣለን",
    version_created_pre: "ስሪት ",
    version_created_post: " ተፈጢሩ",
    hist_updated: "ታሪኽ ኣብ ገጽ ምክፍፋል ተሓዲሱ።",
    toast_version_err: "ስሪት ክፍጠር ኣይከኣለን",
  },
};
